import { makeTrackingFunction } from '../use-freshpaint';

export const enum BookingEvent {
  clicked_to_view = 'clicked_to_view',
  clicked_to_book = 'clicked_to_book',
}

type ClickedToView = {
  eventName: BookingEvent.clicked_to_view;
  payload: {
    location: string;
    providerName: string;
  };
};

export const trackClickedToView = makeTrackingFunction<ClickedToView>(BookingEvent.clicked_to_view);

type ClickedToBook = {
  eventName: BookingEvent.clicked_to_book;
  payload: {
    location: string;
  };
};

export const trackClickedToBook = makeTrackingFunction<ClickedToBook>(BookingEvent.clicked_to_book);